<template>
    <confirmation-page-layout :company="company" :loaded="loaded" :tourlead="tourlead">
        <template v-slot:breadcrumbs>
            <insurance-breadcrumbs :search-request="searchRequest" />
        </template>
        <template v-slot:sidebar>
            <insurance-search-summary :search-request="searchRequest" search-disabled />
            <insurance-order-summary
                :search-request="searchRequest"
                :offer="offer"
                :prepare-book-response="prepareBookResponse"
                :product="product"
            />
            <insurance-info-modal />
        </template>
    </confirmation-page-layout>
</template>

<script lang="ts">
    import {Component, mixins} from 'vue-facing-decorator'
    import ConfirmationPageLayout from '@/components/parts/ConfirmationPageLayout.vue'
    import InsuranceBreadcrumbs from '@/components/insurance/InsuranceBreadcrumbs.vue'
    import {ConfirmationPageMixin} from '@/mixins/ConfirmationPageMixin.vue'
    import {InsurancePageMixin} from '@/components/insurance/mixins/InsurancePageMixin.vue'
    import InsuranceSearchSummary from '@/components/insurance/search/InsuranceSearchSummary.vue'
    import InsuranceOrderSummary from '@/components/insurance/booking/InsuranceOrderSummary.vue'
    import InsuranceInfoModal from '@/components/insurance/info/InsuranceInfoModal.vue'
    import {InsuranceStoreMixin} from '~/mixins/InsuranceStoreMixin.vue'

    @Component({
        components: {
            InsuranceInfoModal,
            ConfirmationPageLayout,
            InsuranceBreadcrumbs,
            InsuranceSearchSummary,
            InsuranceOrderSummary,
        },
        async setup() {
            return await useConfirmationPage()
        },
    })
    export class InsuranceConfirmationPage extends mixins(
        ConfirmationPageMixin,
        InsurancePageMixin,
        InsuranceStoreMixin
    ) {
        get basketItem() {
            return insuranceStore.basketItem(insuranceStore.prepareBookRequest.offerKey)
        }

        get offer() {
            return this.basketItem.product.offers.find(
                offer => offer.offerKey === insuranceStore.prepareBookRequest.offerKey
            )
        }

        get searchRequest() {
            return this.basketItem.searchRequest
        }

        get product() {
            return this.basketItem.product
        }
    }

    export default InsuranceConfirmationPage
</script>
